import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderDetailsLineCollectionModel, OrderDetailsParams } from "@tKgpco/Services/GetOrderLineDetailsService";
import { getMessagesParameter, MessageCollectionModel } from "@tKgpco/Services/OrderDetailsMessageCollection";
import { LoadOrderLinesDetailState } from "@tKgpco/Store/Data/OrderHistoryDetail/LoadOrderLineDetailsState";
import { LoadOrderDetailMessagesState } from "@tKgpco/Store/Data/OrderHistoryDetail/LoadOrderMessagesState";
import { Draft } from "immer";

const initialState: LoadOrderDetailMessagesState = {
    isLoading: false,
    collection: null,
};

const reducer = {
    "Data/Orders/BeginLoadMessages": (
        draft: Draft<LoadOrderDetailMessagesState>,
        action: { parameter: getMessagesParameter },
    ) => {
        draft.isLoading = true;
    },
    "Data/Orders/CompleteLoadMessages": (
        draft: Draft<LoadOrderDetailMessagesState>,
        action: { parameter: getMessagesParameter; collection: MessageCollectionModel[] },
    ) => {
        draft.isLoading = false;
        draft.collection = action.collection;
    },
    // "Custom/Orders/ResetLoadOrderDetailsLine": (draft: Draft<LoadOrderLinesDetailState>) => {
    //     draft.isLoading = {};
    //     draft.collection = [];
    // },
};

export default createTypedReducerWithImmer(initialState, reducer);
